import { useMemo } from "react";

import type { IndividualSubscription } from "../../../hooks/useTeamsTypes";
import useTranslation from "../../../hooks/useTranslation";
import CTARow from "../../CTARow/CTARow";
import { CTARowDivider } from "../../CTARowDivider/CTARowDivider";
import { SubscriptionExpirationText } from "../SubscriptionExpirationText/SubscriptionExpirationText";
import {
  formatExpirationDate,
  getPlanDisplayName,
  getSourceDisplayName,
} from "../subscriptionUtils";

export const PaddleOneTimeSubscriptionInfo: React.FC<{ subscription: IndividualSubscription }> = ({
  subscription,
}) => {
  const { t, m } = useTranslation();
  const planName = getPlanDisplayName(
    subscription.type,
    subscription.subscriptionPeriod,
    subscription.tier,
    undefined,
    t
  );
  const expirationDate = new Date(subscription.expirationDate);
  const sourceName = useMemo(
    () => getSourceDisplayName(subscription.type, t),
    [subscription.type, t]
  );

  return (
    <>
      <CTARow title={t(m.TeamSubscriptionPage.LicenseTitle)} text={planName} />
      <CTARowDivider />
      <CTARow
        title={
          <SubscriptionExpirationText
            autoRenews={false}
            subscriptionType={subscription.type}
            expirationDate={expirationDate}
            subscriptionTier={subscription.tier}
          />
        }
        text={formatExpirationDate(subscription.expirationDate)}
      />
      <CTARowDivider />
      <CTARow title={t(m.TeamSubscriptionPage.PurchasedVia)} text={sourceName} />
    </>
  );
};
